export default __webpack_public_path__ + "static/media/home_black_24dp.a0c1b0a7.svg";